/* @flow */
import { default as moment } from "moment";

type MomentType = any;

const exported = {
    moreThanAmountOfMinutesAgo(time: MomentType | undefined | null, amountOfMinutes: number): boolean {
        if (!time) {
            return true;
        }
        return moment().subtract(amountOfMinutes, "minutes").isAfter(time);
    },

    getCurrentMonth(): MomentType {
        return moment().startOf("month");
    }
};

export default exported;

export const { moreThanAmountOfMinutesAgo, getCurrentMonth } = exported;
